export default __webpack_public_path__ + "static/media/bouncy-man.382e9466.png";